import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=1132c6d6&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=1132c6d6&prod&lang=css&"
import style1 from "./dialog.vue?vue&type=style&index=1&id=1132c6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132c6d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VDivider,VIcon,VRow})
